import script from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"

import "./MenuLayout.vue?vue&type=style&index=0&id=b898758c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/evyd/Stage/client-stage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b898758c"]])

export default __exports__